import { Box, Typography } from "@mui/material";
import { useRecord } from "../../api/useRecord";

type OrderPurchaseNotesProps = {
    priceNotes?: string;
    insuranceNumber?: string;
    treatmentId?: number | string;
};

export const OrderPurchaseNotes = ({ priceNotes, insuranceNumber, treatmentId }: OrderPurchaseNotesProps) => {
    const { data } = useRecord("treatments", "price_notes,client.insurance_number", treatmentId, {
        enabled: !!treatmentId,
    });

    const displayPriceNotes = priceNotes || data?.item?.price_notes;
    const displayInsuranceNumber = insuranceNumber || data?.item?.client?.insurance_number;
    const hasContent = displayPriceNotes || displayInsuranceNumber;

    if (!hasContent) return null;

    return (
        <Box>
            <Typography variant="body1" color="primary" mb={1}>
                Notas para compras:
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                {displayPriceNotes && (
                    <Typography variant="body2">
                        <strong>Preço:</strong> {displayPriceNotes}
                    </Typography>
                )}
                {displayInsuranceNumber && (
                    <Typography variant="body2">
                        <strong>Seguro:</strong> {displayInsuranceNumber}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

